import * as React from 'react';
export const HeartBreakIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill="#505CFF"
      d="M13.906 3.125a4.812 4.812 0 0 0-3.425 1.419L10 5.025l-.481-.481A4.844 4.844 0 0 0 1.25 7.969c0 5.468 8.109 9.896 8.454 10.078a.625.625 0 0 0 .592 0c.345-.182 8.454-4.61 8.454-10.078a4.849 4.849 0 0 0-4.844-4.844ZM10 16.781c-1.427-.831-7.5-4.618-7.5-8.812a3.594 3.594 0 0 1 6.135-2.542l.481.482-.808.81a.625.625 0 0 0 0 .883l1.916 1.917-1.291 1.29a.625.625 0 0 0 .884.885L11.55 9.96a.625.625 0 0 0 0-.883L9.634 7.159l1.73-1.732A3.594 3.594 0 0 1 17.5 7.97c0 4.188-6.075 7.98-7.5 8.812Z"
    />
  </svg>
);
